(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-price', class extends baseComponent.default {
        
    render() { 
      this.listenTo('variantChange', (e, data) => {
        this._update(data.html);
        this.style.display = 'block';
        
        try{
          this.classList.remove("wpd-processed");
          this.setAttribute("data-wpd-variant-compare-at-price",data.variant.compare_at_price == null?"":data.variant.compare_at_price);
          this.setAttribute("data-wpd-variant-price",data.variant.price);
          this.setAttribute("data-wpd-variant-id",data.variant.id);
          // this._update.setAttribute("data-wpd-product-handle", document.querySelector("#wpdproduct-modal").value);
            
          }catch(e){}
      })
      this.listenTo('sellingPlanChange', (e, data) => {
        this._update(data.html);
        
      })
      
      
    };
    _update(html) { 
      const source = html.querySelector('product-price');
      // console.log(source.innerHTML);
      // this.innerHTML = source.innerHTML;
      this.replaceChildren(...source.cloneNode(true).childNodes);
    };
  });
})();